import {useGetConsingmentQuery} from '@states/consignment/consignment.api'

const useGetOneConsignment = (id: string | number) => {
    const {
        data: rawData,
        error,
        isLoading,
        refetch,
    } = useGetConsingmentQuery({
        consignment_id: id!,
    });
   
    const consignmentResponse =
        rawData as any;
    return {
        consignmentData: consignmentResponse?.data,
        consignmentMessage: consignmentResponse?.message,
        consignmentSuccess: consignmentResponse?.success,
        consignmentError: error,
        consignmentLoading: isLoading,
        consignmentRefetch: refetch, 
    };
};

export default useGetOneConsignment;
